import AdminOnboarding from './AdminOnboarding';

export { default as AdminOnboardingWhat } from './AdminOnboardingWhat';
export { default as AdminOnboardingHow } from './AdminOnboardingHow';
export { default as AdminOnboardingTeam } from './AdminOnboardingTeam';
export { default as AdminOnboardingTools } from './AdminOnboardingTools';
export { default as AdminOnboardingInviteTeam } from './AdminOnboardingInviteTeam';
export { default as AdminOnboardingRedirect } from './AdminOnboardingRedirect';
export { default as AdminOnboardingFieldLabel } from './AdminOnboardingFieldLabel';

export default AdminOnboarding;
